import React from "react"
import Title from "../Title"
import styles from "../../css/briefbio.module.css"
import AniLink from "gatsby-plugin-transition-link/AniLink"
// import img from "../../images/defaultBcg.jpeg"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"




const BriefBio = () => {


  return (
    <section className={styles.bio}>
      <Title title="Solution" subtitle="Architect" />
      <div className={styles.bioCenter}>
        <article className={styles.bioImg}>
          <div className={styles.pContainer}>
            
           <h2>Hi There</h2>
          </div>
        </article>
        <article className={styles.bioInfo}>
          
          <p>
          I am someone who works with people to understand 
          their business challenges and pain points, and then looks for 
          the best technical solution available  
          to solve those problems. 
</p>
         
          <AniLink fade to="/about" className="btn-primary">
        learn more
      </AniLink>

 

        </article>
      </div>
    </section>
  )
}

// I'm an experienced IT specialist, specializing in supporting applications
// focusing on user experience, and front-end design 
// — with over 2  years of technical experience and software implementations.
// I've worked closely with large companies in the Healtcare IT sector as well as local companies to help promote their brand and marketing.


export default BriefBio
